<template>
    <div class="mt-5 mb-5 pt-5 pb-5 bg-white loading-global d-flex j-content-center a-i-center direction-column">
        <p class="uppercase title-big t-white150 text-center no-select text-motserrat-16">Loading</p>
    </div>
</template>

<style lang="scss">
@import './loading.scss';
</style>
